import React from "react";
import { useSpring, animated } from "react-spring";
import "./inforesidential.scss";

function Number({ n }) {
  const { number } = useSpring({
    from: { number: 0 },
    number: n,
    delay: 500,
    config: { mass: 1, tension: 20, friction: 10 },
  });
  return <animated.div>{number.to((n) => n.toFixed(0))}</animated.div>;
}

const inforesidential = () => {
  return (
    <div className="inforesidential">
      <div className="container-inforesidential">
        <div className="content-number">
          <div className="number">
            <Number n={1} />
            <span>.</span>
            <Number n={1} />
            <span>K</span>
          </div>
          <div className="ket">Hectare</div>
        </div>

        <div className="vl"></div>
        <div className="content-number">
          <div className="number">
            <Number n={20} />
            <span>K</span>
          </div>
          <div className="ket">Population</div>
        </div>
        <div className="vl"></div>
        <div className="content-number">
          <div className="number">
            <Number n={7} />
            <span>.</span>
            <Number n={2} />
            <span>ha</span>
          </div>
          <div className="ket">Waterpark</div>
        </div>
        <div className="vl"></div>
        <div className="content-number">
          <div className="number">
            <Number n={4} />
            <span>.</span>
            <Number n={2} />
            <span>ha</span>
          </div>
          <div className="ket">Mall</div>
        </div>
      </div>
    </div>
  );
};

export default inforesidential;
